"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SystemDetailTile = require("@ccw-pwa-ui/SystemDetailTile");
var _images = _interopRequireWildcard(require("../common_features/assets/images"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SystemGatewayComponent = _ref => {
  let {
    systemType,
    onclick,
    gateways,
    gatewayType,
    systems,
    waterDestinationItem,
    gatewayName,
    optionBtnClick,
    isDisable,
    rightArrowBtn,
    everythingOkText,
    statusIcon,
    statusText,
    dscIcon,
    isPartial,
    onPartialClick,
    onPartialDelete,
    partialLogo,
    deleteLogo
  } = _ref;
  const getGatewayStatus = Aitem => {
    return Aitem.online ? everythingOkText : /*#__PURE__*/_react.default.createElement("span", {
      style: {
        color: '#9A9A9A'
      }
    }, "Gateway is Offline");
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-detail-tile-wrapper"
  }, systems === null || systems === void 0 ? void 0 : systems.map(Aitem => {
    var _Aitem$item;
    let alist = [];
    (_Aitem$item = Aitem.item) === null || _Aitem$item === void 0 ? void 0 : _Aitem$item.forEach(element => {
      alist = [...alist, {
        ...element,
        optionBtnClick: () => optionBtnClick(element, "detail")
      }];
    });
    const isPartial = Aitem.isComplete;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: Aitem.systemId
    }, /*#__PURE__*/_react.default.createElement(_SystemDetailTile.SystemDetailTile, {
      type: systemType,
      item: Aitem,
      alertList: alist,
      onclick: () => {
        onclick(Aitem, "system");
      },
      onPartialClick: () => onPartialClick(Aitem, "system"),
      onPartialDelete: () => onPartialDelete(Aitem),
      tileImage: Aitem.systemImageUrl ? Aitem.systemImageUrl : _images.default.noImg.default,
      tileHeading: Aitem.systemPartNumber,
      tileSubHeading: Aitem.systemModelNumber,
      waterDestinationItem: waterDestinationItem
      // optionBtnClick={(() => optionBtnClick(Aitem,"system"))}
      ,
      isDisable: isDisable,
      rightArrowBtn: rightArrowBtn,
      everythingOkText: everythingOkText,
      arrowRightColorIcon: _images.default.ArrowRight.default,
      dscIcon: dscIcon,
      isPartial: isPartial,
      partialLogo: partialLogo,
      deleteLogo: deleteLogo,
      incompleteSystemText: "Incomplete System"
    }));
  }), gateways === null || gateways === void 0 ? void 0 : gateways.map(Aitem => {
    var _Aitem$item2;
    let alist = [];
    (_Aitem$item2 = Aitem.item) === null || _Aitem$item2 === void 0 ? void 0 : _Aitem$item2.forEach(element => {
      alist = [...alist, {
        ...element,
        optionBtnClick: () => optionBtnClick(element, "detail")
      }];
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      key: Aitem.deviceType
    }, /*#__PURE__*/_react.default.createElement(_SystemDetailTile.SystemDetailTile, {
      type: gatewayType,
      item: Aitem,
      alertList: alist,
      onclick: () => {
        onclick(Aitem, "gateway");
      },
      tileImage: Aitem.gatewayImageUrl ? Aitem.gatewayImageUrl : _images.default.noImg.default,
      tileHeading: gatewayName,
      tileSubHeading: Aitem.deviceType,
      waterDestinationItem: waterDestinationItem
      // optionBtnClick={(() => optionBtnClick(Aitem,"gateway"))}
      ,
      isDisable: isDisable,
      rightArrowBtn: rightArrowBtn,
      isPartial: true,
      arrowRightColorIcon: _images.default.ArrowRight.default
      // everythingOkText={Aitem.online ? everythingOkText : <span style={{ color: '#9A9A9A' }}>Gateway is Offline</span>}
      ,
      everythingOkText: !isDisable ? everythingOkText : getGatewayStatus(Aitem),
      statusIcon: Aitem.online ? _images.onlineHub.default : _images.offlineHub.default,
      statusText: Aitem.online ? "Online" : /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: '#9A9A9A'
        }
      }, "Offline"),
      isPartial: true
    }));
  })));
};
var _default = exports.default = SystemGatewayComponent;